import classNames from 'classnames'

import { CommonHorizontalArrow7Icon, CommonNIcon, HeaderSettingIcon } from '@local/assets/icons'
import { CLICK_CODE } from '@local/utils'

import useScroll from '@web/hooks/useScroll'
import { DEFAULT_PROFILE_IMAGE } from '@web/libs/constants'
import { Nullish } from '@web/types'
import Clickable from '@web/ui/components/Clickable'
import { HEIGHT_HEADER } from '@web/ui/components/Header/constant'
import Image from '@web/ui/components/Image'

import styles from './Header.module.scss'

export interface HomeHeaderProps extends DefaultProfileHeaderProps {
  showProfileOnScroll?: boolean
  onNaverClick?: () => void
  onMyplaceClick?: () => void
  onSettingClick?: () => void
  onLoginClick?: () => void
  isFromMapsApp?: Nullish<boolean>
  login: boolean
}

export function HomeHeader(props: HomeHeaderProps) {
  const {
    showProfileOnScroll,
    onNaverClick,
    onMyplaceClick,
    onSettingClick,
    onLoginClick,
    nickname,
    borderImageUrl,
    profileImageUrl,
    isFromMapsApp,
    login,
  } = props

  const thresholdShowProfile = useScroll((_: number, y: number) => y > HEIGHT_HEADER)
  const thresholdFixedHeader = showProfileOnScroll && thresholdShowProfile

  if (isFromMapsApp) {
    return thresholdFixedHeader ? (
      <header className={classNames(styles.header, { [styles.type_fixed]: thresholdFixedHeader })}>
        <div className={styles.inner}>
          <h1 className={styles.title_area}>
            <DefaultProfileHeader
              login={login}
              nickname={nickname}
              borderImageUrl={borderImageUrl}
              profileImageUrl={profileImageUrl}
              onLoginClick={onLoginClick}
            />
          </h1>
        </div>
      </header>
    ) : null
  }

  return (
    <>
      <header className={classNames(styles.header, { [styles.type_fixed]: thresholdFixedHeader })}>
        <div className={styles.inner}>
          <h1 className={styles.title_area}>
            {thresholdFixedHeader ? (
              <DefaultProfileHeader
                login={login}
                nickname={nickname}
                borderImageUrl={borderImageUrl}
                profileImageUrl={profileImageUrl}
                onLoginClick={onLoginClick}
              />
            ) : (
              <div className={styles.page_name_wrapper}>
                <Clickable
                  className={styles.logo_naver}
                  onClick={onNaverClick}
                  nClickCode={CLICK_CODE['gnb.navermain']}
                >
                  <CommonNIcon className={styles.icon} aria-hidden="true" />
                  <span className="place_blind">네이버</span>
                </Clickable>
                <Clickable
                  className={styles.logo_myplace}
                  onClick={onMyplaceClick}
                  nClickCode={CLICK_CODE['gnb.myplace']}
                >
                  MY플레이스
                </Clickable>
              </div>
            )}
          </h1>
          {
            <div className={classNames(styles.btn_area, styles.type_position_right)}>
              <Clickable className={styles.btn} onClick={onSettingClick} nClickCode={CLICK_CODE['gnb.settings']}>
                <HeaderSettingIcon className={styles.icon} aria-hidden="true" />
                <span className="place_blind">설정</span>
              </Clickable>
            </div>
          }
        </div>
      </header>
      {/* Note: fixed 시 높이 보정을 위한 더미 구조 */}
      {thresholdFixedHeader && <div style={{ height: `${HEIGHT_HEADER}px` }} />}
    </>
  )
}

interface DefaultProfileHeaderProps {
  login: boolean
  nickname?: string
  borderImageUrl?: Nullish<string>
  profileImageUrl?: Nullish<string>
  onLoginClick?: () => void
}

function DefaultProfileHeader({
  profileImageUrl,
  borderImageUrl,
  nickname,
  login = false,
  onLoginClick,
}: DefaultProfileHeaderProps) {
  return (
    <div className={styles.profile_wrapper}>
      <div className={styles.profile_thumb_area}>
        <div className={styles.thumb_area}>
          <Image
            className={styles.img}
            src={profileImageUrl ?? DEFAULT_PROFILE_IMAGE}
            width="30"
            height="30"
            alt="프로필"
          />
          {borderImageUrl && (
            <Image className={styles.img_profile_border} src={borderImageUrl} width="40" height="40" alt="프로필 띠" />
          )}
        </div>
      </div>
      <div className={styles.profile_info_area}>
        <div className={styles.name_area}>
          {login ? (
            <span className={styles.name}>{nickname}</span>
          ) : (
            <Clickable className={styles.name} onClick={onLoginClick}>
              로그인해주세요.
              <CommonHorizontalArrow7Icon className={styles.icon_arrow} aria-hidden="true" />
            </Clickable>
          )}
        </div>
      </div>
    </div>
  )
}
